const ES = {
    title: 'Resúmenes',
    table: {
        title: 'Listado de resúmenes',
        columns: {
            id: 'ID',
            period: 'Período',
            pdf: 'PDF',
            date: 'Fecha de emisión',
            document: 'INE',
            lastFour: 'Últimos 4'
        },
    }
};

export default ES;
